import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MapViewService } from 'src/app/shared/components/map-view/map-view.service';
import { SheetsService } from 'src/app/shared/components/sheets/sheets.service';

@Component({
  selector: 'app-location-result-card',
  templateUrl: './location-result-card.component.html',
  styleUrls: ['./location-result-card.component.scss']
})
export class LocationResultCardComponent implements OnInit {
  isActive = false;
  hideBasedlevel = false;
  showNetworkButton = true;
  showNetworks = false;
  showHours = false;
  locationSpecialties = [];

  @Input() location: any;
  @Input() showLevels: boolean;
  @Input() showLeveledNetworks: boolean;
  @Input() drSpecialties: [];
  @Input() showPromoted: boolean;
  @Input() params: any;
  @ViewChild('locationCard', { static: false }) locationCard: ElementRef;

  @Output() locationDataChange = new EventEmitter();

  @Input()
  set activeMarkerLetter(letter: string) {
    this.isActive = (letter === (this.location && this.location.address && this.location.address.letter));
    if (this.isActive) {
      if (this.locationCard) {
        setTimeout(() => {
          this.locationCard.nativeElement.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
        }, 0);
      }
    }
  }

  @Input()
  set showLevel1(showLevel1: boolean) {
    if (this.showLevels) {
      this.showOnlyLevelLocation(showLevel1);
    }
  }

  constructor(private router: Router, private sheetsService: SheetsService, private mapViewService: MapViewService) { }

  ngOnInit() {
    this.activeSpecialties();
    this.checkSameNetwork();
  }

  activeSpecialties() {
    for (const drSpecialty of this.drSpecialties) {
      const sObj = {
        name: drSpecialty,
        active: false
      };

      for (const specialty of this.location.specialties) {
        if (specialty === drSpecialty) {
          sObj.active = true;
          break;
        }
      }

      this.locationSpecialties.push(sObj);
    }
    this.locationSpecialties.sort((a, b) => b.active - a.active);
  }

  checkSameNetwork() {
    if (this.location.plansAccepted.length === 1) {
      if (this.location.plansAccepted[0].subproductkey === this.params.subProductKey) {
        this.showNetworkButton = false;
      }
    }
  }

  showNetworksDropdown() {
    this.showNetworks = !this.showNetworks;
  }

  clickDistance(event) {
    // sheet function
    this.sheetsService.changeSheets({ locations : [this.location] });
    event.stopPropagation();
  }

  clickDetailLocation(event) {
    // send location to parent and display data
    if (event.view.getSelection().toString().length === 0) {
      this.locationDataChange.emit(this.location);
    }
  }

  showOnlyLevelLocation(showLevel1) {
    if (showLevel1) {
      if (this.location.level === '2') {
        this.hideBasedlevel = true;
      } else {
        this.hideBasedlevel = false;
      }
    } else if (!showLevel1) {
      if (this.location.level === '1') {
        this.hideBasedlevel = true;
      } else {
        this.hideBasedlevel = false;
      }
    }
  }


  setMouseEnter(event) {
    this.location.isInView = true;
    this.mapViewService.updateDetailsMapMarker.emit(this.location);
  }

  setMouseLeave(event) {
    this.location.isInView = false;
    this.mapViewService.updateDetailsMapMarker.emit(this.location);
  }
}
